'use client'

import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html lang="tr">
            <body>
                <div className="min-h-screen flex items-center justify-center bg-white">
                    <div className="text-center space-y-6 p-8">
                        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                            <AlertTriangle className="w-8 h-8 text-red-600" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-gray-900 mb-2">
                                Kritik Hata
                            </h2>
                            <p className="text-gray-600">
                                Uygulama genelinde bir hata olustu. Lutfen sayfayi yenileyin.
                            </p>
                        </div>
                        <Button onClick={() => reset()}>
                            Tekrar Dene
                        </Button>
                    </div>
                </div>
            </body>
        </html>
    )
}
